import { ASSET_PREFIX } from "utils/constants";
import styles from './TotalEntriesCounter.module.css';

interface ITotalEntriesCounter {
  totalEntries: number
}

const TotalEntriesCounter = ({ totalEntries }: ITotalEntriesCounter) => {
  const totalEntriesDigits = totalEntries.toString().split('');
  // If the total number of entries is < 100, pad with '0's until we have a 3-digit number.
  while (totalEntriesDigits.length < 3) {
    totalEntriesDigits.unshift('0');
  }
  return (
    <div className={styles.totalEntriesCounter}>
      <img
        className={styles.ticketIcon}
        src={`${ASSET_PREFIX}/images/token-town/ticket.png`}
      />

      <div className={styles.labelContainer}>
        <h4>
          Entries Sold :
        </h4>
      </div>
      {totalEntriesDigits.map((digit, idx) => (
        <div className={styles.digitContainer} key={idx}>
          <h4 className={`${styles.digit} `}>
            {digit}
          </h4>
        </div>
      ))}
    </div>
  );
};

export default TotalEntriesCounter;
